import React, {Component} from 'react';
import {connect} from 'react-redux';
import PlayersDashboardFactory from './factory';

class PlayersDashboard extends Component {
    render() {
        const {sportConfig} = this.props;

        const PlayersDashboard = PlayersDashboardFactory.getComponent(sportConfig);

        return <PlayersDashboard />;
    }
}

function mapStatesToProps(state) {
    return {
        sportConfig: state.sportConfig,
    };
}

export default connect(mapStatesToProps)(PlayersDashboard);
